// extracted by mini-css-extract-plugin
export default {"loggedOutToPatients":"LoggedOutAndBuyRateCard_loggedOutToPatients__Zd37p","textContainer":"LoggedOutAndBuyRateCard_textContainer__4z5+P"};